/* Change this file to get your personal Portfolio */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Jean Christopher",
  title: "Hi all, I'm Jean Christopher",
  subTitle: emoji(
    "A passionate Data Scientist and Software Developer with experience in Machine Learning, Computer Vision, and building intelligent solutions. I enjoy solving challenging problems using Python, SQL, and modern AI frameworks."
  ),
  //resumeLink: "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/jchristopherj",
  linkedin: "https://www.linkedin.com/in/jchristopherj",
  gmail: "jeanchristopher.contato@gmail.com",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "DATA SCIENTIST AND FULL STACK DEVELOPER WITH EXPERIENCE IN AI AND MEDICAL IMAGING",
  skills: [
    emoji("⚡ Build and deploy machine learning models for complex problems"),
    emoji("⚡ Develop full stack web applications and visualizations"),
    emoji("⚡ Analyze and process structured and unstructured data including medical images"),
    emoji("⚡ Apply advanced techniques in Computer Vision and Zero-Shot Segmentation")
  ],
  softwareSkills: [
    { skillName: "Python (Advanced)", fontAwesomeClassname: "fab fa-python" },
    { skillName: "Machine Learning", fontAwesomeClassname: "fas fa-robot" },
    { skillName: "Computer Vision", fontAwesomeClassname: "fas fa-eye" },
    { skillName: "Medical Imaging", fontAwesomeClassname: "fas fa-x-ray" },
    { skillName: "Image Segmentation", fontAwesomeClassname: "fas fa-vector-square" }
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Universidade Federal de Ouro Preto (UFOP)",
      logo: require("./assets/images/logo-ufop.png"),
      subHeader: "Master's in Computer Science",
      duration: "2021 - 2024",
      desc: "Thesis on zero-shot segmentation of MRI images using SAM (Segment Anything Model).",
      descBullets: [
        "Developed the SMASH heuristic for post-processing",
        "Achieved superior performance over traditional tools"
      ]
    },
    {
      schoolName: "Universidad Tecnológica del Uruguay (UTEC)",
      logo: require("./assets/images/utec.png"),
      subHeader: "Postgraduate in Robotics and Artificial Intelligence (in progress)",
      duration: "2024 - Present",
      desc: "Specialization in intelligent systems and robotics."
    },
    {
      schoolName: "Instituto Federal de Minas Gerais (IFMG)",
      logo: require("./assets/images/ifmg.png"),
      subHeader: "Bachelor's in Information Systems",
      duration: "2010 - 2014",
      desc: "Foundation in computing, software engineering, and systems analysis."
    }
  ]
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Director of IT",
      company: "City Hall of São Sebastião do Maranhão",
      companylogo: require("./assets/images/ssm.png"),
      date: "Mar 2021 – Present",
      desc: "Leads the design and implementation of technological solutions, infrastructure management, and support services."
    },
    {
      role: "Freelancer: Web Developer & IT Technician",
      company: "Self-employed",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "2007 – 2021",
      desc: "Created websites using WordPress and provided technical support in networks, hardware, and digital services."
    }
  ]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "I'm open to new opportunities and collaborations.",
  number: "+55 33 98806-6002",
  email_address: "jeanchristopher.contato@gmail.com"
};

const isHireable = true;
const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !"}

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};
const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};
const bigProjects = {
  title: "Big Projects",
  subtitle: "Let's do this together",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};


const techStack = {
  title: "Big Projects",
  subtitle: "Let's do this together",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};
// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

 

export {
  illustration,
  bigProjects,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  techStack,
  openSource,  
  achievementSection,
  blogSection,
  talkSection,
  podcastSection, 
  twitterDetails,
  contactInfo,
  isHireable,
  resumeSection
};